import { useState, useEffect } from "react";

const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(false);

  if (typeof window !== "undefined") {
    useEffect(() => {
      const media = window.matchMedia(query);
      if (media.matches !== matches) {
        setMatches(media.matches);
      }
      const listener = (e) => setMatches(media.matches);
      window.addEventListener("resize", listener);
      return () => {
        window.removeEventListener("resize", listener);
      };
    }, [matches, query]);
  }

  return matches;
};

export default useMediaQuery;

// A  How to use this hook

// 1.  define hook

// 2. const isMobile = useMediaQuery('(min-width: 991px)');

// 3. Use this condition to render things

// 4. {isMobile ? true : false}
